import { useState } from "react";
import MarkdownDisplay from "./markdownDisplay.jsx";

function ChevronIcon({ open }) {
  return (
    <svg
      className={`w-5 h-5 flex-shrink-0 text-primary transition-transform duration-200 ${open ? "rotate-180" : ""}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

export default function AccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-border-default">
      <button
        type="button"
        className="w-full flex items-center justify-between py-5 text-left text-primary font-semibold text-lg gap-4 cursor-pointer"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <span>{question}</span>
        <ChevronIcon open={open} />
      </button>
      <div
        data-testid="accordion-panel"
        className={`overflow-hidden transition-all duration-200 ${open ? "max-h-[2000px]" : "max-h-0"}`}
        aria-hidden={!open}
      >
        <div className="pb-5 text-text-strong prose prose-sm max-w-none">
          <MarkdownDisplay data={answer || ""} />
        </div>
      </div>
    </div>
  );
}
